import { React } from "react"
import stocksTnC from "../../assets/stocksTnCText.txt"
import stocksPrivacy from "../../assets/stocksPrivacyText.txt"
import CustomFooter from "./CustomFooter"

function StocksFooter({ id, rrn, opt, redirect }) {
  return (
    <CustomFooter
      id={id}
      rrn={rrn}
      opt={opt}
      redirect={redirect}
      privacyText={stocksPrivacy}
      tncText={stocksTnC}
    />
  )
}

export default StocksFooter
